import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { InsightType } from '../types';
import Legend from './Legend';
import Insight from './Insight/Insight';
import { Tabs } from '../DefaultReports';
import { useIntl } from 'react-intl';

interface Props {
  setSection: (sectionName: string) => void;
  selectedSection?: string;
  dataToDisplay: InsightType[];
  changeTab: (tab: Tabs) => void;
  disableGoToResults?: boolean;
}

const Content = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-left: 2rem;

  & > div:first-of-type {
    position: relative;
    margin-bottom: 4rem;
    border-right: 1px solid ${({ theme }) => theme.colors.quillGray};
    width: 30rem;
    margin-left: -2rem;
    background-color: white;
  }
`;

const InsightsContainer = styled.div`
  width: 100%;
  padding: 1rem 2rem;
`;

const Insights = ({
  setSection,
  selectedSection,
  dataToDisplay,
  changeTab,
  disableGoToResults,
}: Props) => {
  const { locale } = useIntl();

  useEffect(() => {
    if (selectedSection) {
      const elemToScroll = document.getElementById(selectedSection);
      const isDataToDisplay = dataToDisplay && dataToDisplay.length > 0;
      if (!isDataToDisplay) return;

      const firstElement =
        typeof dataToDisplay[0].title === 'string'
          ? dataToDisplay[0].title
          : //@ts-ignore
            dataToDisplay[0].title[locale];
      if (elemToScroll) {
        // HACK to do not scroll if 1st element is shown
        const isFirst =
          elemToScroll.id === firstElement && window.pageYOffset === 0;

        const y =
          elemToScroll.getBoundingClientRect().top + window.pageYOffset + -85;

        !isFirst && window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  }, [selectedSection, dataToDisplay, locale]);

  return (
    <Content>
      <Legend
        setSection={setSection}
        selectedSection={selectedSection}
        reportsLegend={[...dataToDisplay]}
      />
      <InsightsContainer>
        {dataToDisplay.map((insight: InsightType, index: number) => (
          <Insight
            insight={insight}
            key={index}
            changeTab={changeTab}
            disableGoToResults={disableGoToResults}
          />
        ))}
      </InsightsContainer>
    </Content>
  );
};

export default Insights;
